import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class DesignDataFormFileModel extends ModelBase<DesignDataFormFileModel> {
    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DESIGNDATA_ID = "";
    public static readonly DEFAULT_FILENAME = "";
    public static readonly DEFAULT_FILEURL = "";
    public static readonly DEFAULT_CREATED_BY_USER_ID = null;
    public static readonly DEFAULT_IS_DELETED = false;

    @observable
    public id: string | null = DesignDataFormFileModel.DEFAULT_ID;
    @observable
    public designDataId: string = DesignDataFormFileModel.DEFAULT_DESIGNDATA_ID;
    @observable
    public fileName: string = DesignDataFormFileModel.DEFAULT_FILENAME;
    @observable
    public fileURL: string = DesignDataFormFileModel.DEFAULT_FILEURL;
    @observable
    public createdByUserId: string | null = DesignDataFormFileModel.DEFAULT_CREATED_BY_USER_ID;
    @observable
    public isDeleted: boolean = DesignDataFormFileModel.DEFAULT_IS_DELETED;

    @action
    public reset = () => {
        this.id = DesignDataFormFileModel.DEFAULT_ID;
        this.designDataId = DesignDataFormFileModel.DEFAULT_DESIGNDATA_ID;
        this.fileName = DesignDataFormFileModel.DEFAULT_FILENAME;
        this.fileURL = DesignDataFormFileModel.DEFAULT_FILEURL;
        this.createdByUserId = DesignDataFormFileModel.DEFAULT_CREATED_BY_USER_ID;
        this.isDeleted = DesignDataFormFileModel.DEFAULT_IS_DELETED;
    };

    @action
    public fromDto(dto: DesignDataFileDTO): void {
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    public toDto(): DesignDataFileDTO {
        const designDataFormFileModel: DesignDataFileDTO = {
            id: this.id,
            designDataId: this.designDataId,
            fileName: this.fileName,
            fileURL: this.fileURL,
            createdByUserId: this.createdByUserId,
            isDeleted: this.isDeleted,
        };

        return designDataFormFileModel;
    }
}

export interface DesignDataFileDTO {
    id: string | null;
    designDataId: string | null;
    fileName: string;
    fileURL: string;
    createdByUserId: string | null;
    isDeleted: boolean;
}
